module.exports = __webpack_public_path__ + "static/media/wrinkles_fullface.33544643.svg";